import Aos from "aos";
import "aos/dist/aos";
import React, { useEffect } from "react";
import { Col } from "react-bootstrap";
import Rating from "react-rating";
import { Link } from "react-router-dom";
import "./SingleHomeWatch.css";

const SingleHomeWatch = ({ watch }) => {
  //Destructuring
  const { _id, name, img, price, rating, brand } = watch;

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <Col lg={3} md={3} sm={12} xs={12}>
      <div data-aos="zoom-out" className="watchDetails">
        <div className="singleImg">
          <img src={img} alt="watch" />
        </div>
        <h3>Model: {name}</h3>
        <h5>{brand}</h5>
        <Rating
          className="my-3"
          emptySymbol="fa fa-star-o fa-2x"
          fullSymbol="fa fa-star fa-2x"
          initialRating={rating}
          readonly
        ></Rating>
        <h2>$ {price}</h2>
        <Link to={`/detailsAndBooking/${_id}`}>
          <button>Purchase and Details</button>
        </Link>
      </div>
    </Col>
  );
};

export default SingleHomeWatch;
